import React, { useEffect,useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Mousewheel,Pagination, Navigation } from "swiper";
import { MoonLoader } from 'react-spinners';






function MovieDetails(props) {
    let {id} = useParams();
    console.log(id);
    let [movieDetails,setMovieDetails] = useState({});
    let [movieVideos,setMovieVideos] = useState(null);
    let [similarMovies,setSimilarMovies] = useState(null);
    let [movieCast,setMovieCast] = useState(null);


    async function getMovieDetails(){
      let {data} = await axios.get(`https://api.themoviedb.org/3/movie/${id}?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`)
      setMovieDetails(data);
    }
    async function getVideos(){
        let {data} = await axios.get(`https://api.themoviedb.org/3/movie/${id}/videos?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`)
        let movieVideos = data.results;
        let movieTrailer = movieVideos.filter(elem => elem.type == "Trailer");
        setMovieVideos(movieTrailer[0] != undefined? movieTrailer[0].key : movieTrailer)
        
        
    }
    async function getSimilarMovies(){
        let {data} = await axios.get(`https://api.themoviedb.org/3/movie/${id}/similar?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US&page=1`)
        setSimilarMovies(data.results);
    }
    async function getMovieCast(){
        let {data} = await axios.get(`https://api.themoviedb.org/3/movie/${id}/credits?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`)
        setMovieCast(data.cast.filter(elem => elem.profile_path != null && elem.adult == false));
    }
    async function up(){
        window.scrollTo(0,0);
     }
    useEffect(() =>{
        getMovieDetails();
        getVideos();
        getSimilarMovies();
        getMovieCast();
        up()

    },[id])
    return<>
    { similarMovies && movieVideos && movieCast? <>
    <div className="container p-4">
        <div className="row">
            <div className="col-md-4">
                <div>
                    <img className='w-100 rounded-3' src={`https://image.tmdb.org/t/p/w500/${movieDetails.poster_path}`} alt="movie info" />
                </div>
            </div>
            <div className="col-md-8">
                <div>
                    <h2>{movieDetails.title}</h2>
                    <p className='text-muted'>{movieDetails.tagline}</p>
                    <div className='row gy-1 align-items-center'>
                        {movieDetails.genres?.map((genre, idx) => <div key={idx} className='col-md-3'>
                            <div className='bg-info p-2 rounded-5 text-center text-white'>{genre.name}</div>
                        </div>)}
                        </div>
                    <div><iframe className='mt-3 rounded-2 w-100' height="450" src={`https://www.youtube.com/embed/${movieVideos}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></div>
                    <h4 className='my-5'>Vote : {movieDetails.vote_average}</h4>
                    <h4 className='my-5'>Vote Count : {movieDetails.vote_count}</h4>
                    <h4 className='my-5'>Popularity : {movieDetails.popularity}</h4>
                    <h4 className='mt-5 mb-4'>Release Date : {movieDetails.release_date}</h4>
                    <div className='my-3 row'>
                    <h4>Cast:</h4>
                    <Swiper
        slidesPerView={4}
        spaceBetween={15}
        slidesPerGroup={4}
        loop={true}
        loopFillGroupWithBlank={true}
        mousewheel={true}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Mousewheel, Navigation]}
        className="mySwiper"
      >
        {movieCast?.map((cast,idx) => <SwiperSlide key={idx}><div className="col-12 my-2 mx-2 rounded-3">
                            <Link to={`/peopledetails/${cast.id}`}>
                            <figure>
                                <img className='w-100 rounded-2' src={`https://image.tmdb.org/t/p/w500${cast.profile_path}`} alt="actor" />
                                <figcaption className='pt-2'>
                                    <h6>{cast.name}</h6>
                                    <h6>{cast.character}</h6>
                                </figcaption>
                            </figure>
                            </Link>
                            </div></SwiperSlide>)}
      </Swiper>    
                    </div>
                    <div className="row align-items-center">
                        <h4>Production Companies :</h4>
                        {movieDetails.production_companies?.map((procomp,idx) => <div key={idx} className="col-2 my-3 mx-3 rounded-3">
                            {procomp.logo_path !== null? <><div>
                            <img className='w-100 rounded-2 my-4' src={`https://image.tmdb.org/t/p/w500${procomp.logo_path}`} alt="production company" />
</div></>:<h6 style={{"fontFamily":"Cairo"}}>{procomp.name}</h6>}
                            </div>)}
                        
                
                    </div>
                    <p className='text-muted'>{movieDetails.overview}</p>
                </div>
            </div>
        </div>
    </div>
    <div className='container'>
    <h2>Similar Movies</h2>
        <div className="row">
        {similarMovies.map((elem,idx) =>
                <div key={idx} className='col-md-2'>
                <Link to={`/moviedetails/${elem.id}`}>
                <div className='imghov'>
                   <figure>
                       <img className='w-100 rounded-2 my-4' src={`https://image.tmdb.org/t/p/w500/${elem.poster_path}`} alt="production company" />
                    </figure>
                    <figcaption className='text-center'>
                        <h6>{elem.title}</h6>
                    </figcaption> 
                </div>
                </Link>
            </div>
            ) } 
            
        </div>
    </div>
</> : <div className='vh-100 d-flex justify-content-center align-items-center'>
    <MoonLoader color="white"/>
    </div>}
    </>
}



export default MovieDetails;